module.exports = __webpack_public_path__ + "static/img/资质中心_banner.907cc25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/资质中心_banner.png
// module id = ZzZh
// module chunks = 1